import React from 'react'

interface IconProps {
  className?: string
}

const Gantt04 = ({ className }: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M8 10C8 9.44772 8.44772 9 9 9H21C21.5523 9 22 9.44772 22 10V14C22 14.5523 21.5523 15 21 15H9C8.44772 15 8 14.5523 8 14V10Z"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M5 16C5 15.4477 5.44772 15 6 15H14C14.5523 15 15 15.4477 15 16V20C15 20.5523 14.5523 21 14 21H6C5.44772 21 5 20.5523 5 20V16Z"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M2 4C2 3.44772 2.44772 3 3 3H10C10.5523 3 11 3.44772 11 4V8C11 8.55228 10.5523 9 10 9H3C2.44772 9 2 8.55228 2 8V4Z"
      stroke="currentColor"
      strokeWidth="2"
    />
  </svg>
)

export default Gantt04
